import { stringify } from 'query-string';

import { sortOrderTypes } from 'types/shared';

interface IRegionsURLArgs {
  regionIds?: string[];
  nameFilter?: string;
  sortOrder?: sortOrderTypes;
  sortBy?: string;
}

export default function getRegionsURL(args: IRegionsURLArgs = {}): string {
  const { regionIds, nameFilter, sortBy, sortOrder } = args;

  const params = stringify({
    regionIds,
    nameFilter,
    sortBy,
    sortOrder,
  });

  return `/api/regions?${params}`;
}
